import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { ComponentType, FC } from 'react'
import { StyleSheet, View } from 'react-native'
import { SvgProps } from 'react-native-svg'

interface OrderDetailInfoRowProps {
    children: string
    bold?: boolean
    Icon: ComponentType<SvgProps>
}

const OrderDetailInfoRow: FC<OrderDetailInfoRowProps> = ({ children, bold, Icon }) => {
    return (
        <View style={styles.container}>
            <Icon height={16} width={16} style={styles.icon} />
            <Typography.Description font={bold ? 'bold' : 'medium'} style={styles.text}>
                {children}
            </Typography.Description>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 8,
    },
    icon: {
        flexShrink: 0,
    },
    text: {
        color: ColorEnum.JET_900,
        flexShrink: 1,
        lineHeight: 16,
    },
})

export default OrderDetailInfoRow
